module.exports = __webpack_public_path__ + "img/67_4.6dea7089.png";